import React from 'react';
import CategoryPage from '../components/CategoryPage';

const DayOfficesPage = () => {
  return <CategoryPage categoryId="day-offices" />;
};

export default DayOfficesPage;